import { useEffect, useState } from "react";
import { supabase } from "../lib/supabase";

export default function SelectActiveDoctor({ clinicId, onSelect }) {
  const [doctors, setDoctors] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedId, setSelectedId] = useState("");

  useEffect(() => {
    async function fetchDoctors() {
      const { data, error } = await supabase
        .from("clinic_practitioners")
        .select("id, full_name, role")
        .eq("clinic_id", clinicId)
        .order("full_name", { ascending: true });

      if (error) console.error("Error fetching practitioners:", error);
      setDoctors(data || []);
      setLoading(false);
    }
    fetchDoctors();
  }, [clinicId]);

  async function handleSelect() {
    if (!selectedId) return alert("Please select a practitioner to continue");
    const doctor = doctors.find((d) => d.id === selectedId);
    localStorage.setItem("activeDoctor", JSON.stringify(doctor));
    onSelect(doctor);
  }

  if (loading)
    return (
      <div className="flex h-screen items-center justify-center text-gray-600">
        Loading practitioners…
      </div>
    );

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-white text-gray-700">
      <h2 className="text-lg font-semibold mb-6">
        Please select the person currently using the account
      </h2>

      <select
        className="border border-gray-300 rounded-md px-4 py-2 text-sm w-64 mb-4"
        value={selectedId}
        onChange={(e) => setSelectedId(e.target.value)}
      >
        <option value="">Select a practitioner</option>
        {doctors.map((doc) => (
          <option key={doc.id} value={doc.id}>
            {doc.full_name} — {doc.role}
          </option>
        ))}
      </select>

      <button
        onClick={handleSelect}
        className="bg-blue-600 text-white px-6 py-2 rounded-md text-sm hover:bg-blue-700"
      >
        Continue
      </button>
    </div>
  );
}
